.root {
  border: 1px solid var(--paletteNeutral0);
  border-radius: var(--radiusMd);
}

.header {
  align-items: center;
  padding: var(--spacingSm) var(--spacingMd);
  width: 100%;
  background: var(--paletteNeutral2);
  border-radius: var(--radiusMd);
}

.headerContent {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.center {
  display: inline-flex;
  align-items: center;
  gap: var(--spacingSm);
}
